import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { groupBy } from "lodash";
import { makeObservable, observable, action, runInAction } from "mobx";
import { projectsDataStore } from "Stores/ProjectsStore";
import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { XKTViewerStore } from "./XKTViewerStore";

interface XKTSearchStoreInitProps {
  fileId: number;
}

export interface IfcSearchResult {
  type: string;
  objects: Pick<API_IfcSearchResult, "guid" | "name" | "type">[];
}

export class XKTSearchStore extends CoreStore {
  fileId: number = null;
  isVisible: boolean = false;
  objectTypes: string[] = [];
  searchResult: IfcSearchResult[] = [];
  context: XKTViewerStore = null;
  contextMenu = null;

  constructor(instance: XKTViewerStore) {
    super();
    makeObservable(this, {
      // observables
      objectTypes: observable,
      // actions
      clear: action.bound,
      getObjectTypes: action.bound,
      init: action.bound,
      searchIfc: action.bound,
      setFileId: action.bound,
    });
    this.context = instance;
  }

  url() {
    return API_URL.BIM.metaObjectTypes(projectsDataStore.projectId, this.fileId, 0);
  }

  clear() {
    this.objectTypes = [];
  }

  init({ fileId }: XKTSearchStoreInitProps) {
    this.fileId = fileId;
    this.getObjectTypes();
  }

  async getObjectTypes() {
    try {
      const response = await API.getData(this.url());
      runInAction(() => {
        if (response.length) {
          this.objectTypes = response;
        }
      });
    } catch (error) {
      throw error;
    }
  }

  async fetchAttributes(formBody: API_IfcPropertyTypeRequest): Promise<API_IfcPropertyDetail[]> {
    try {
      return await API.newData<API_IfcPropertyDetail[]>(
        API_URL.BIM.propertyTypes(projectsDataStore.projectId, this.fileId, 0),
        formBody
      );
    } catch (error) {
      throw error;
    }
  }

  setFileId(fileId: number) {
    this.fileId = fileId;
    this.getObjectTypes();
  }

  @handleStoreState()
  async searchIfc(formData: API_IfcSearchRequest) {
    try {
      const response = await API.newData<API_IfcMetaObject[]>(
        API_URL.BIM.metaObjects(projectsDataStore.projectId, this.fileId, 0),
        formData
      );

      const groupedByType = groupBy(response, "type");
      const fileName = this.context.fileName;
      const searchResult = Object.keys(groupedByType).map((item) => ({
        type: item,
        objects: groupedByType[item].map(({ id, name, type }) => ({ guid: fileName + "#" + id, name, type })),
      }));
      this.context.sdk.sendMessage({ type: "searchResult", payload: { data: searchResult } });
    } catch (error) {
      throw error;
    }
  }
}
